// Hover intent: the open delay keeps a pointer passing over a tab from opening
// its menu. Once a menu is open, moving to another tab switches immediately.
export const HOVER_OPEN_DELAY_MS = 100
export const HOVER_SWITCH_DELAY_MS = 0

// The menu closes only after the pointer has stayed outside the tab + panel
// (grown by the padding) for the close delay without heading back toward it.
export const HOVER_CLOSE_DELAY_MS = 300
export const HOVER_ZONE_PADDING_PX = 8

// Pointer aim: recent pointer positions decide whether the pointer is moving
// toward the open panel. Older samples than the stale window mean it stopped.
export const POINTER_TRAIL_LENGTH = 4
export const POINTER_AIM_STALE_MS = 150

export const ITEM_KINDS = {
  classList: 'classList',
  link: 'link',
  sectionLabel: 'sectionLabel',
}

export const EMPTY_CLASS_LIST_MESSAGES = {
  1: 'No classes created',
  2: 'No small groups created',
}

// Under this many pixels from the bottom, a column counts as scrolled to the end.
export const SCROLL_END_TOLERANCE_PX = 1
